module.exports = __webpack_public_path__ + "static/cover-3-7c6d5d48d3c6e92cee07fec59d94f0bb.png";